const to_array     = require('./to_array')

/**
 * Função para colocar a etapa atual do relatório em visualização
 */
function HistoryReport() {
  const check = checkExistsTimeLine();
  scrollTo(check);
}

/**
 * Cheacando se o componente faz parte da página
 *
 * @return {boll}
 */
function checkExistsTimeLine() {
  const existisApprovalFlow = document.querySelector('.approval-flow');
  if (existisApprovalFlow != null) {
    return true;
  }
  return false;
}

/**
 * Rolagem para que a etapa atual fique vísivel
 *
 * @param  {bool} check
 */
function scrollTo(check) {
  if (check) {
    const currentStage = document.querySelector('#approval-flow__holder--waiting');
    if (currentStage != null) {
      $('.approval-flow__content').animate({
        scrollTop: $('#approval-flow__holder--waiting').offset().top
      }, 1000);
      return;
    }
    $('.approval-flow__content').animate({
      scrollTop: $('.approval-flow__wrapper .approval-flow__holder:last-child').offset().top
    }, 1000)
  }
  return;
}
exports.init = HistoryReport;

